import React, { useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import { Colors } from "assets/colors";
import RssFeedTwoToneIcon from '@mui/icons-material/RssFeedTwoTone';
import {  getAllTrucks } from 'apis/device';
import TruckModal from "../../components/TruckModal/TruckModal";
import DeleteTruckModal from "../../components/TruckModal/DeleteTruckModal";
import TruckDataTable from "../../components/DataTable/TruckDataTable";
import CommonUtil from "../../common/CommonUtil";
import TruckTableHeader from "../../components/TableHeader/TruckTableHeader";
import moment from "moment";

interface TruckManagerProps {
}

const TruckManager: React.FC<TruckManagerProps> = () => {
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [truckData, setTruckData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [truckToDelete, setTruckToDelete] = useState(null);
  const [deleteTruck, setDeleteTruck] = useState(false);
  const [editDevice, setEditDevice] = useState(false);
  const [truckToEdit, setTruckToEdit] = useState(null);
  const [err, setErr] = useState("");
  const [page, setPage] = useState(0);
  const [deviceDataAfterFilter, setDeviceDataAfterFilter] = useState([]);

  const getTruckList = async () => {
    setIsLoading(true);
    let data = await getAllTrucks();
    if (data?.response?.data?.errorMessage) {
      setErr(data.response.data.errorMessage);
      return
    }
    if (data && data.length > 0) {
      data.forEach((object: any) => {
        if ('creationDate' in object && object.creationDate !== null) {
          const obj = object.creationDate;
          if(obj.includes('+0000')){
            const date = new Date(object.creationDate);
            object.creationDate = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
          }
          else{
            object.creationDate = new Date(object.creationDate).toLocaleString();
          }
      }
        if ('lastUpdateDate' in object && object.lastUpdateDate !== null) {
          const obj = object.lastUpdateDate;
          if(obj.includes('+0000')){
            const date = new Date(object.lastUpdateDate);
            object.lastUpdateDate = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
          }
          else{
            object.lastUpdateDate = new Date(object.lastUpdateDate).toLocaleString();
          }
        }
      });
      const sortedArray = data.sort((a: any, b: any) => {
        // Convert the lastUpdateDate strings to Date objects
        const dateA = new Date(a.lastUpdateDate);
        const dateB = new Date(b.lastUpdateDate);

        // Compare the dates and return the result
        if (dateA > dateB) {
          return -1;
        } else if (dateA < dateB) {
          return 1;
        } else {
          return 0;
        }
      });
      setTruckData(sortedArray);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    getTruckList();
  }, [])


  let tableButtons = [
    {
      label: "Add Truck",
      onClickHandler: () => setShowModal(true),
      buttonStyle: { backgroundColor: Colors.Red, },
      icon: <RssFeedTwoToneIcon sx={{ marginRight: ".5rem" }} />
    }
  ]

  if(!CommonUtil.isScreenButtonAvailable(CommonUtil.TRUCK_MANAGER,CommonUtil.UPDATE_MODE)){
    tableButtons = [];
  }

  const handleModalAction = async (val: string, data: any) => {
    console.log(val);
    if(val === "deleteTruck") {
      setTruckToDelete(data);
      setDeleteTruck(true);
      setPage(Math.random()*10000);

    }
    if(val === "editTruck") {
      setTruckToEdit(data);
      setShowModal(true);
    }
  };

  const closeDeleteModal = () => {
    setDeleteTruck(false);
    setTruckToDelete(null);
  }

  useEffect(() => {
    if(!showModal) {
      setTruckToEdit(null);
      setTruckToDelete(null);
    }
  }, [showModal]);

    // Downloading Only Filtered Data After Search
  const updateFilteredData = (data:[]) => {
    setDeviceDataAfterFilter(data);
  }

  return (
    <Grid container spacing={2}>
       {showModal && <TruckModal open={showModal} handleClose={setShowModal} getTruckList={getTruckList} truckToEdit={truckToEdit}/>}
      {truckToDelete !== null && <DeleteTruckModal open={deleteTruck} handleClose={closeDeleteModal} truck={truckToDelete} getTruck={getTruckList}/>}
      <TruckTableHeader actionButtons={tableButtons} searchVal={searchVal} setSearchVal={setSearchVal} data={deviceDataAfterFilter} csvLabel={"trucks.csv"} screenName={CommonUtil.TRUCKS}/>
      <Grid item xs={12} sx={{ height: "80vh" }}>
        <TruckDataTable data={truckData} searchVal={searchVal} openModal={handleModalAction} getFilteredData={updateFilteredData}/>
      </Grid>
    </Grid>
  )
}

export default TruckManager;
